export default (props, e) => {
    const target = document.querySelector(e.target.getAttribute('href'));
    if (target) {
        e.preventDefault();
        console.log("test scroll");
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', offsetTop: -200 });
    }
};


// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/webActions/scrollToHref.js